import { ENDPOINT_NAMES, endpoints } from '../../config/endpoints';
import { sortSubjectsByGrade } from '../../utilities/subjects/sorter';
import { useData } from '@llt-frontend/react-fetch';
import useStudentStateStandardId from '../utility/use-student-state-standard-id';
import useUserContext from '../context/use-user-context';

// Exports
// -------

export default function useStudentSubjects({
  studentId,
  subjectFilter,
  subjectSorter = sortSubjectsByGrade,
} = {}) {
  const { activeStudentId: defaultStudentId } = useUserContext();

  const standardId = useStudentStateStandardId();
  const subjectsEndpoint = endpoints.get(ENDPOINT_NAMES.studentSubjects, {
    standardId,
    studentId: studentId || defaultStudentId,
  });

  const subjects = useData(subjectsEndpoint.path, {
    queryKey: subjectsEndpoint.key,
    queryOptions: {
      select(data) {
        const subjects = subjectFilter ? subjectFilter(data) : [...data];
        return subjects.sort(subjectSorter);
      },
    },
  });

  //
  // Result

  return {
    ...subjects,
    get error() {
      if (!subjects.error && !subjects.data && !subjects.loading) {
        return {
          message: 'Unable to load student subjects',
        };
      }

      // This will be undefined when no error has occurred and will provide a falsy value to check
      // against.
      return subjects.error;
    },
  };
}
